/* Progressive enhancement only: article text and links remain server rendered. */
(() => {
  function enhance(root) {
    if (root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const body = root.querySelector('[data-cs-content]');
    if (!body) return;
    const headings = Array.from(body.querySelectorAll('h2')).filter(h => h.textContent.trim());
    const usedIds = new Set(Array.from(document.querySelectorAll('[id]'), e => e.id));
    headings.forEach((heading, i) => {
      if (!heading.id) {
        let id = 'guide-' + (heading.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || i);
        while (usedIds.has(id)) id += '-section';
        heading.id = id;
        usedIds.add(id);
      }
    });
    if (headings.length > 1) {
      root.querySelectorAll('[data-cs-toc-list]').forEach(list => {
        headings.forEach(heading => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          item.append(link); list.append(item);
        });
      });
      root.querySelectorAll('[data-cs-toc]').forEach(toc => { toc.hidden = false; });
      // Replace only the old, explicitly labelled table of contents, never article copy.
      body.querySelectorAll(':scope > div').forEach(div => {
        const label = div.querySelector('p:first-child > strong');
        if (label && /^(on this page|table of contents)$/i.test(label.textContent.trim())) div.hidden = true;
      });
      if ('IntersectionObserver' in window) {
        const links = Array.from(root.querySelectorAll('[data-cs-toc-list] a'));
        const observer = new IntersectionObserver(entries => {
          const visible = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (!visible.length) return;
          links.forEach(link => {
            if (decodeURIComponent(link.hash.slice(1)) === visible[0].target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }, {rootMargin:'-120px 0px -55% 0px', threshold:0});
        headings.forEach(h => observer.observe(h));
      }
    }
    body.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('cs-table-wrap')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cs-table-wrap'; wrapper.tabIndex = 0;
      wrapper.setAttribute('role','region'); wrapper.setAttribute('aria-label','Scrollable comparison table');
      table.before(wrapper); wrapper.append(table);
    });
  }
  document.querySelectorAll('[data-cs-article]').forEach(enhance);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cs-article]').forEach(enhance));
})();
